import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { IAction } from 'src/app/domain/IAction';
import { API_PATH } from 'src/environments/environment';

const RELATIVE_URL = 'system-action-params';

@Injectable({
  providedIn: 'root'
})
export class ActionService {
  getJsonActions() {
    return this.httpClient.get<IAction[]>('assets/system-actions.json').pipe(
      map((data) => data),
      catchError((error) => throwError(error))
    )
  }

  constructor(protected httpClient: HttpClient) { }

  public save(data: IAction[]): Observable<IAction[]> {
    return this.httpClient.post<IAction[]>(`${API_PATH}${RELATIVE_URL}/save-alfasu-erp-web`, data);
  }
}
